export default __webpack_public_path__ + "static/purple-bg-dc160daa70dd5659f7a3f49aa2a38067.png";